enum ErrorMessages {
  // Fetch Errors
  FetchVehicleError = 'Vehicle Fetch Error',
  FetchVehicleSpecsError = 'Vehicle Specs Fetch Error',
  FetchDealersError = 'Dealers Fetch Error',
  FetchDealerError = 'Dealer Fetch Error',
  FetchInventoryError = 'Fetch Inventory Error',
  FetchAttributesError = 'Fetch Attributes Error',
  FetchModelOverviewError = 'Fetch Model Overview Error'
}

export default ErrorMessages;
